/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type OrderByRelationalPropertyDto = {
  /**
   * The property name to order by (supports dot-notation for relations, e.g., "user.email")
   */
  propertyName: string;
  /**
   * The order direction (asc or desc)
   */
  value: OrderByRelationalPropertyDto.value;
};
export namespace OrderByRelationalPropertyDto {
  /**
   * The order direction (asc or desc)
   */
  export enum value {
    ASC = 'asc',
    DESC = 'desc',
  }
}
